module.exports = __webpack_public_path__ + "static/banner3_mobile-fd5cc4714830a717230d85dee83491e4.jpg";